export const ADD_CHART3_VALUES = "ADD_CHART3_VALUES";
export const ADD_CHART4_VALUES = "ADD_CHART4_VALUES";
export const ADD_CHART5_VALUES = "ADD_CHART5_VALUES";
export const ADD_CHART6_VALUES = "ADD_CHART6_VALUES";
